(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-atelier"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initFooter = (root) => {
      if (!root || root.dataset.ftrInit === 'true') return;
      root.dataset.ftrInit = 'true';
      const mq = window.matchMedia('(max-width: 749px)');

      root.querySelectorAll('.ftr-col').forEach((col) => {
        const head = col.querySelector('.ftr-col__head');
        const panel = col.querySelector('.ftr-col__list');
        if (!head || !panel) return;

        const setOpen = (open) => {
          head.setAttribute('aria-expanded', String(open));
          if (open) {
            panel.classList.add('is-open');
            panel.style.height = panel.scrollHeight + 'px';
            panel.addEventListener('transitionend', function te(e) {
              if (e.propertyName !== 'height') return;
              panel.style.height = 'auto';
              panel.removeEventListener('transitionend', te);
            });
          } else {
            panel.style.height = panel.scrollHeight + 'px';
            requestAnimationFrame(() => { panel.style.height = '0px'; });
            panel.classList.remove('is-open');
          }
        };

        const applyMode = () => {
          if (mq.matches) {
            const wantOpen = head.getAttribute('aria-expanded') === 'true';
            panel.style.height = wantOpen ? 'auto' : '0px';
            if (wantOpen) panel.classList.add('is-open'); else panel.classList.remove('is-open');
          } else {
            panel.style.height = '';
            panel.classList.remove('is-open');
          }
        };

        head.addEventListener('click', () => {
          if (!mq.matches) return;
          const open = head.getAttribute('aria-expanded') === 'true';
          setOpen(!open);
        });

        applyMode();
        (mq.addEventListener ? mq.addEventListener('change', applyMode) : mq.addListener(applyMode));
      });
    };

    const initAll = () => document.querySelectorAll('footer.ftr').forEach(initFooter);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else { initAll(); }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
